import React from "react";
import DashboardLayout from "../../layout/DashboardLayout.js";
// import ProfileDetails from "./ProfileDetails.js";
import SharedListsDetails from "./SharedListsDetails.js";
// import { Box } from "@mui/material";
// import { getUserById } from "../../services/userService";


function SharedListView() {
  // const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <DashboardLayout pageName="Profile">
      {/* <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' },  gap: 2}}> */}
        <SharedListsDetails />
      {/* </Box> */}
    </DashboardLayout>
  );
}

export default SharedListView;